import {HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) : Observable<HttpEvent<unknown>> {
  if (req.context.get(SKIP_AUTH_TOKEN))
    return next(req);

  const token = inject(AuthService).getAuthToken();
  const newReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
  return next(newReq);
}

export const SKIP_AUTH_TOKEN = new HttpContextToken<boolean>(() => false);

